var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShippingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 30,
    viewBox: "0 0 59 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.6416 24.4476H58.3335V22.9147H57.0138V14.8766C57.0138 14.6766 56.9605 14.4767 56.8539 14.3034L51.9617 6.22534C51.7618 5.89209 51.4019 5.69214 51.0153 5.69214H44.057C43.4438 5.69214 42.9506 6.18535 42.9506 6.79854V23.3412C42.9506 23.9544 42.4574 24.4476 41.8442 24.4476H33.0996",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.328 24.4479H18.0361",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7823 6.58425C19.7823 6.58425 19.3424 9.50355 22.0485 9.45023V20.6609H37.5781V9.79681C37.5781 9.79681 39.6042 9.65018 39.6042 6.57092H19.7823V6.58425Z",
    fill: "#E5DDF6",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4552 29.02C49.1559 29.02 50.5345 27.6413 50.5345 25.9407C50.5345 24.2401 49.1559 22.8615 47.4552 22.8615C45.7546 22.8615 44.376 24.2401 44.376 25.9407C44.376 27.6413 45.7546 29.02 47.4552 29.02Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.713 29.02C30.4137 29.02 31.7923 27.6413 31.7923 25.9407C31.7923 24.2401 30.4137 22.8615 28.713 22.8615C27.0124 22.8615 25.6338 24.2401 25.6338 25.9407C25.6338 27.6413 27.0124 29.02 28.713 29.02Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2014 15.0089C52.7617 12.7961 51.0555 10.1568 49.6158 7.94397C48.2962 7.91731 46.6299 7.90398 45.2969 7.87732L45.7901 15.0089C48.6694 15.0489 51.4154 15.1422 54.2014 15.0089Z",
    fill: "#E5DDF6",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9664 20.1949L29.6732 6.49153C29.6598 5.81169 29.4199 4.18542 29.3399 3.50558C29.2599 2.82574 29.0466 2.14591 28.5801 1.63936C28.1135 1.13282 27.367 0.852888 26.7272 1.0795C25.9807 1.33277 25.5541 2.29254 25.8741 3.01237C26.1273 3.59889 26.7272 3.94547 27.2871 4.25207C28.1135 4.69196 28.9267 5.14519 29.7531 5.58508C29.4465 4.55866 29.6065 3.41227 30.193 2.51915C30.5796 1.9193 31.2861 1.41275 31.9526 1.63936C32.6191 1.85265 32.899 2.7191 32.6724 3.37228C32.4458 4.02546 31.8593 4.50534 31.2461 4.83859C30.6329 5.17185 29.9664 5.39846 29.3932 5.78503",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0649 13.5835C9.93181 14.0234 8.5988 13.8901 7.55905 13.2503C7.02585 12.917 6.54596 12.3971 6.54596 11.7706C6.54596 11.1441 7.25246 10.5576 7.79899 10.8508C8.10559 11.0241 8.23889 11.3974 8.21223 11.7439C8.18557 12.0905 8.02561 12.4105 7.85231 12.7037C7.23913 13.7701 6.31935 14.7032 5.15963 15.1031C3.99991 15.503 2.57359 15.2498 1.78711 14.3033",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1294 19.1558C15.7564 19.729 14.2101 19.8889 12.7572 19.5957C12.2506 19.489 11.7441 19.3291 11.3575 18.9958C10.9709 18.6626 10.731 18.116 10.8776 17.6228C11.0242 17.1296 11.6374 16.7964 12.0773 17.0363C12.5572 17.2896 12.5972 18.0094 12.2906 18.4626C11.984 18.9158 11.4508 19.1291 10.9309 19.3024C7.69172 20.3688 4.02594 20.0756 1 18.4893",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingIcon);
export default __webpack_public_path__ + "static/media/shippingIcon.47bae7d462977080072667a794b83fa5.svg";
export { ForwardRef as ReactComponent };